"use client";

import { useEffect, useState } from "react";
import axios from "axios";

interface Device {
  id: number;
  name: string;
  slug: string;
  image: string;
}

interface DetailLayananData {
  id: number;
  name: string;
  slug: string;
  keyword: string;
  description: string;
  image: string;
  content: string;
  device: Device;
}

interface ApiResponse {
  status: number;
  message: string;
  data: DetailLayananData | DetailLayananData[]; // Mengizinkan baik array atau objek tunggal
}

export const useFetchDetailLayananData = (device: string, slug?: string) => {
  const [detailLayanan, setDetailLayanan] = useState<DetailLayananData[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const url = slug
          ? `https://admin.macspace.id/public/api/detail_service/${device}/${slug}`
          : `https://admin.macspace.id/public/api/detail_service/${device}`;
        const response = await axios.get<ApiResponse>(url);
        // Menangani data jika objek tunggal
        const data = Array.isArray(response.data.data)
          ? response.data.data
          : [response.data.data];
        setDetailLayanan(data);
      } catch (error) {
        console.log(error);
        setDetailLayanan([]);
      }
    };
    fetchData();
  }, [device, slug]);

  return detailLayanan;
};
